import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/car/in/list/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/car/in/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/car/in/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/car/in/submit/v2', params, options);

export const update = (params, options) => request.post('/api/park/car/in/submit/v2', params, options);
